/* @jsx mdx */
import React from 'react'
import { mdx } from '@mdx-js/react'

import { Cite, Slide, Heading, Text, Box, FlexBox, Image, Appear, Markdown } from "spectacle";
import {LeftContentRightContent, LeftCodeRightContent, LeftCodeRightMarkdown, LeftContentRightMarkdown, LeftCodeRightCode} from "components/layout";

function MDXContentWrapperSlide0(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */




const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    {
      /* prettier-ignore-start */
    }
    {
      /* prettier-ignore-end */
    }
    <h4>{`Requests for Feedback and Help`}</h4>
    <ul>
      <li parentName="ul">{`Lots of open Redux docs rewrite issues: `}<a parentName="li" {...{
          "href": "https://github.com/reduxjs/redux/issues/3592"
        }}>{`issue #3592`}</a>
        <ul parentName="li">
          <li parentName="ul">{`Add new content`}</li>
          <li parentName="ul">{`Move existing content around`}</li>
          <li parentName="ul">{`Clean up existing content`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Investigation of React-Redux, Concurrent Mode, and `}<inlineCode parentName="li">{`useMutableSource`}</inlineCode></li>
      <li parentName="ul">{`Help updating my React/Redux links list repo`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide0.isMDXComponent = true;

function MDXContentWrapperNotes0(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */




const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes0.isMDXComponent = true;


export const notes = [MDXContentWrapperNotes0];


export default [MDXContentWrapperSlide0]